import React from 'react'

const WorkspaceIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='14'
    height='14'
    viewBox='0 0 14 14'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M2.91663 12.25V8.16667C2.91663 7.84583 3.03086 7.57118 3.25933 7.34271C3.48781 7.11424 3.76246 7 4.08329 7H4.66663V5.83333H4.08329C3.76246 5.83333 3.48781 5.7191 3.25933 5.49062C3.03086 5.26215 2.91663 4.9875 2.91663 4.66667V2.91667C2.91663 2.59583 3.03086 2.32118 3.25933 2.09271C3.48781 1.86424 3.76246 1.75 4.08329 1.75H9.91663C10.2375 1.75 10.5121 1.86424 10.7406 2.09271C10.9691 2.32118 11.0833 2.59583 11.0833 2.91667V4.66667C11.0833 4.9875 10.9691 5.26215 10.7406 5.49062C10.5121 5.7191 10.2375 5.83333 9.91663 5.83333H9.33329V7H9.91663C10.2375 7 10.5121 7.11424 10.7406 7.34271C10.9691 7.57118 11.0833 7.84583 11.0833 8.16667V12.25H9.91663V10.5H4.08329V12.25H2.91663ZM5.83329 7H8.16663V5.83333H5.83329V7Z'
      fill='currentColor'
    />
  </svg>
)

export default WorkspaceIcon
